import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createChat, type Chat } from "~/entities/chat";
import { chatDetailKey } from "~/entities/chat/useActiveChat";

interface CreateChatVars {
    workspaceId: string;
    projectId?: string;
    sceneId?: string;
    title?: string;
}

export function useCreateChat() {
    const qc = useQueryClient();
    return useMutation<Chat, Error, CreateChatVars>({
        mutationFn: (vars) => createChat(vars),
        onSuccess: (chat) => {
            // Detail-кэш нужен ChatShell после navigate (шапка, rename-actions).
            // chatListKey намеренно не трогаем — чат появляется в сайдбаре
            // только после успешного auto-rename (см. useSubmitLocalMessage).
            qc.setQueryData<Chat>(chatDetailKey(chat.id), chat);
        },
    });
}
